import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  MODOS,
  aplicarTemaGuardado,
  establecerTema,
  iniciarEscuchaDelSistema,
  obtenerTemaPreferido,
  suscribirseAlTema,
} from './tema.js';

const ContextoDeTema = createContext(null);

/**
 * Proveedor del tema (D-08, RF-032).
 *
 * El primer pintado YA aplico el tema desde el script de index.html: aqui solo se
 * mantiene sincronizado el estado de React y se escucha al sistema operativo para
 * que el modo Automatico cambie en vivo, sin recargar y sin perder lo que se este
 * capturando (RN-045a, RN-045c).
 */
export function ProveedorDeTema({ children }) {
  const [preferencia, setPreferencia] = useState(() => obtenerTemaPreferido());

  useEffect(() => {
    aplicarTemaGuardado();
    const dejarDeEscucharAlTema = suscribirseAlTema(setPreferencia);
    const dejarDeEscucharAlSistema = iniciarEscuchaDelSistema();
    return () => {
      dejarDeEscucharAlTema();
      dejarDeEscucharAlSistema();
    };
  }, []);

  const valor = useMemo(() => ({
    ...preferencia,
    modos: MODOS,
    cambiarTema: (modo) => setPreferencia(establecerTema(modo)),
  }), [preferencia]);

  return <ContextoDeTema.Provider value={valor}>{children}</ContextoDeTema.Provider>;
}

export function useTema() {
  const contexto = useContext(ContextoDeTema);
  if (!contexto) throw new Error('useTema debe usarse dentro de ProveedorDeTema.');
  return contexto;
}
